module.exports = __webpack_public_path__ + "img/v-logo.30244d7a.png";